import React, { useState } from 'react';
import { Button } from '@/components/ui/button';
import { Link } from 'react-router-dom';
import { Navigation } from '@/components/Navigation';
import { Footer } from '@/components/Footer';
import CanonicalTag from '@/components/CanonicalTag';
import aduRentalPermitsImage from '@/assets/adu-rental-permits.jpg';

const DoYouNeedPermitLicenseRentADUCalifornia = () => {
  const [showCalendly, setShowCalendly] = useState(false);
  const openCalendlyModal = () => setShowCalendly(true);
  const closeCalendlyModal = () => setShowCalendly(false);

  return (
    <>
      <CanonicalTag url="https://www.udaadu.com/permit-license-rent-adu-california" />
      
      {/* Calendly Modal */}
      {showCalendly && (
        <div className="fixed inset-0 z-50 flex items-center justify-center bg-black bg-opacity-50 p-4">
          <div className="relative bg-white rounded-lg w-full max-w-4xl h-full max-h-[90vh]">
            <button 
              onClick={closeCalendlyModal} 
              className="absolute top-4 right-4 z-10 p-2 bg-white rounded-full shadow-md hover:bg-gray-100 transition-colors"
            >
              ✕
            </button>
            <iframe 
              src="https://calendly.com/udaadu?embed=true&hide_gdpr_banner=1" 
              width="100%" 
              height="100%" 
              frameBorder="0" 
              title="Schedule a meeting"
            />
          </div>
        </div>
      )}
      
      <div className="min-h-screen bg-background">
        <Navigation />
        
        <main className="container mx-auto px-4 py-8">
          {/* Hero Section */}
          <div className="mb-12">
            <img 
              src={aduRentalPermitsImage} 
              alt="Homeowner reviewing ADU rental permits" 
              className="w-full h-64 md:h-96 object-cover rounded-lg mb-8"
            />
            
            <h1 className="text-4xl md:text-5xl font-bold mb-6" style={{ color: '#E4683B' }}>
              Do You Need a Permit or License to Rent an ADU in California?
            </h1>
            
            <p className="text-lg md:text-xl text-white leading-relaxed mb-8">
              Understand if permits or licenses are required to rent out an ADU in California, including rental regulations, business licenses, and city-specific requirements.
            </p>
          </div>

          {/* Content Sections */}
          <div className="space-y-12">
            <section>
              <h2 className="text-3xl font-bold mb-6" style={{ color: '#E4683B' }}>
                Rental Permitting and Licensing for ADUs
              </h2>
              <p className="text-white leading-relaxed mb-6">
                California does not require state-level rental licenses for ADUs, but many cities mandate local business licenses or rental permits for landlord activities. Requirements vary significantly by jurisdiction, with some cities requiring registration, inspection, and ongoing compliance monitoring. Property owners should verify local requirements before advertising ADU rentals.
              </p>
            </section>

            <section>
              <h2 className="text-3xl font-bold mb-6" style={{ color: '#E4683B' }}>
                California Tenant and Landlord Laws
              </h2>
              <p className="text-white leading-relaxed mb-6">
                ADU rentals must comply with California tenant protection laws including habitability standards, security deposit limits, and eviction procedures. Landlords need business licenses in many jurisdictions, liability insurance coverage, and compliance with rent control ordinances where applicable. Proper lease agreements and tenant screening procedures are essential for legal rental operations.
              </p>
            </section>

            <section>
              <h2 className="text-3xl font-bold mb-6" style={{ color: '#E4683B' }}>
                City-specific Rental License Requirements
              </h2>
              <p className="text-white leading-relaxed mb-6">
                Cities like Los Angeles, San Francisco, and San Diego each maintain specific rental licensing requirements for ADUs. Some require annual inspections, tenant registration, and rental unit registration with local housing authorities. Business license fees, permit applications, and compliance documentation vary by city but are generally required before commencing rental activities.
              </p>
            </section>

            <section>
              <h2 className="text-3xl font-bold mb-6" style={{ color: '#E4683B' }}>
                Frequently Asked Questions
              </h2>
              <div className="text-white leading-relaxed space-y-6">
                <div>
                  <p className="font-semibold mb-2">Q: Are rental licenses required to rent an ADU in California?</p>
                  <p>A: Some cities require business or rental licenses; verify local rules before renting your ADU.</p>
                </div>
                
                <div>
                  <p className="font-semibold mb-2">Q: Do I need special permits to rent my ADU short-term (e.g., Airbnb)?</p>
                  <p>A: Yes, most cities require permits or licenses specifically for short-term rentals.</p>
                </div>
              </div>
            </section>
          </div>

          {/* Call-to-Action Buttons */}
          <div className="flex flex-col sm:flex-row gap-4 justify-center mt-12">
            <Button 
              onClick={openCalendlyModal}
              className="bg-primary text-primary-foreground hover:bg-primary/90 px-8 py-3 text-lg"
            >
              Book & Schedule
            </Button>
            <Button 
              asChild
              variant="outline"
              className="border-primary text-primary hover:bg-primary hover:text-primary-foreground px-8 py-3 text-lg"
            >
              <Link to="/landing">Learn More</Link>
            </Button>
          </div>
        </main>

        <Footer />
      </div>
    </>
  );
};

export default DoYouNeedPermitLicenseRentADUCalifornia;